module.exports = new __parcel__URL__("testimoni-johny-mobile.dfee8b00.webp").toString();